import { Link } from 'react-router-dom';
import { useI18n } from '../app/i18n';
import { DemonMark } from '../components/DemonMark';

export default function Landing() {
  const { text } = useI18n();
  return (
    <section className="landing page-shell">
      <div className="landing__copy">
        <div className="landing__brand" aria-hidden="true"><DemonMark /><span>DEVIL'S<br /><b>PAW</b></span></div>
        <h1>{text('landing.tagline')}</h1>
        <p className="lede">{text('landing.description')}</p>
        <div className="button-row">
          <Link className="button button--primary" to="/create">{text('landing.createRoom')}</Link>
          <Link className="button button--secondary" to="/join">{text('landing.joinRoom')}</Link>
        </div>
        <Link className="text-link" to="/how-to-play">{text('landing.howToPlay')}</Link>
      </div>
      <div className="landing__showcase dp-panel" aria-hidden="true">
        <p>{text('landing.exampleLabel')}</p>
        <div className="landing__card-stack">
          <article className="landing__example dp-parchment">
            <strong>{text('landing.exampleWish')}</strong>
            <span>{text('consequence.prefix')}</span>
            <b>{text('landing.exampleCurse')}</b>
            <DemonMark />
          </article>
        </div>
        <small>{text('landing.exampleHint')}</small>
      </div>
    </section>
  );
}
